import React from "react"
import { Link as GatsbyLink } from "gatsby"

import { withHeroContent } from "./withHeroContent"
import { HeroForm } from "../Form/HeroForm"
import { Icon } from "../../../Icon/Icon"
import { StyledRow } from "../../../Styled/Row"
import { StyledContainer } from "../../../Styled/Container"
import { H6, P, RichText } from "../../../Styled/Text"
import {
  Content,
  ContentStack,
  ContentStackItem,
  ContentStackRow,
  ContentStackColumn,
  ContentLinks,
  ContentLink,
  ContentBlock,
  ContentBlockBorder,
  ContentSection,
  ContentRow,
  ContentTitle,
  ContentHeading,
  ContentIcon,
  ContentText,
  ContentHelpButton,
  ContentButton,
} from "./HeroContentStyles"

export const HeroContent = withHeroContent(
  ({ active, animated, container, handleSlide, handleClick, height, items, locales, sizes }): JSX.Element => (
    <StyledContainer width={`xl`}>
      <ContentStack height={height}>
        <ContentStackItem active={active === false}>
          <ContentStackRow items={`stretch`} withWrap={`<sm`} ref={active === false ? container : null}>
            {items?.map(({ _key, heading, icon, title }, index: number) => (
              <ContentStackColumn key={_key} animated={animated} offset={index} width={`w-full md:1/3`}>
                <ContentBlock as={`button`} className={`group`} title={title} onClick={() => handleSlide(index)}>
                  <P as={`h2`} colour={`navy`} withSpacing>
                    <strong>{heading}</strong>
                  </P>
                  <ContentTitle as={`h3`} withSpacing={`xl`}>
                    {title}
                  </ContentTitle>
                  <StyledRow items={`end`} justify={`space-between`}>
                    <Icon name={icon} width={sizes[icon]} />
                    <Icon name={`arrowRight`} width={27} />
                  </StyledRow>
                  <ContentBlockBorder colour={icon} />
                </ContentBlock>
              </ContentStackColumn>
            ))}
          </ContentStackRow>
        </ContentStackItem>
        {items?.map(({ _key, content, description, icon, link, links, linksContent, linksTitle, title: category }, index: number) => (
          <ContentStackItem key={_key} active={active === index}>
            <Content ref={active === index ? container : null}>
              <ContentSection>
                <ContentRow items={`stretch`} justify={`start`}>
                  <ContentIcon width={`1/5`}>
                    <Icon name={icon} width={sizes[icon]} />
                  </ContentIcon>
                  <ContentText width={`4/5`}>
                    <ContentHeading colour={`navy`} italic withSpacing={`xl`}>
                      {description}
                    </ContentHeading>
                    <ContentButton colour={`grey`} onClick={() => handleSlide(false)} title={locales?.additionalHeroBack}>
                      <Icon name={`arrowLeft`} width={16} />
                      <span>{locales?.additionalHeroBack}</span>
                    </ContentButton>
                  </ContentText>
                </ContentRow>
                <ContentBlockBorder colour={icon} />
              </ContentSection>
              <ContentSection bg={`dark`}>
                {content === "links" ? (
                  <ContentLinks>
                    {linksTitle && <H6 colour={`grey`}>{linksTitle}</H6>}
                    {links?.map(({ _key, title, url }) => (
                      <ContentLink as={GatsbyLink} key={_key} onClick={() => handleClick(title, category)} title={title} to={url}>
                        <span>{title}</span>
                        <Icon name={`arrowRight`} width={16} />
                      </ContentLink>
                    ))}
                  </ContentLinks>
                ) : content === "content" ? (
                  <ContentLinks>
                    {linksTitle && <H6 colour={`grey`}>{linksTitle}</H6>}
                    {linksContent && <RichText>{linksContent}</RichText>}
                  </ContentLinks>
                ) : content === "providers" ? (
                  <>{active === index ? <HeroForm /> : <div />}</>
                ) : (
                  <div />
                )}
                {link?.title && link?.url && (
                  <StyledRow justify={`start`} items={`center`}>
                    {content !== "links" && <Icon name={`info`} colour={`teal`} width={16} />}
                    <ContentHelpButton
                      as={link.external ? "a" : GatsbyLink}
                      type={`button`}
                      target={link.external ? "_blank" : null}
                      colour={`text`}
                      onClick={() => handleClick(link.title, category)}
                      spacing={content !== "links"}
                      size={`text`}
                      title={link.title}
                      to={link.url}
                      href={link.url}
                    >
                      {link.title}
                    </ContentHelpButton>
                  </StyledRow>
                )}
              </ContentSection>
            </Content>
          </ContentStackItem>
        ))}
      </ContentStack>
    </StyledContainer>
  )
)
